import type { ReactNode } from 'react';
import { profilePanel } from './tokens';

/** Grouped stat tiles — one panel with internal dividers instead of six floating cards. */
export function StatGrid({ children }: { children: ReactNode }) {
  return (
    <div className={profilePanel}>
      <div className="grid grid-cols-3 divide-x divide-y divide-black/[0.06]">{children}</div>
    </div>
  );
}
